import { IosArrowHorizontalScroller } from '@sgcmpteltd/uikit-react';
import type {
  Props as ScrollerProps,
} from '@sgcmpteltd/uikit-react/components/ios-arrow-horizontal-scroller';
import { useRef } from 'react';

import { AUTO_SCROLL_TO_ACTIVE_INDEX_OFFSET_X } from './constants';
import styles from './styles.module.scss';
import type { Component } from './type';

export const TextIndexesNavigator: Component = ({
  contentContainerElRef,
  arrowLeftContainerClassName,
  arrowRightContainerClassName,
  autoSnapScrollEnd,
  autoSnapScrollEndDebounceWaitMesc,
  className,
  contentContainerClassName,
  scrollDebounceWaitMsec,
  scrollDistance,
  scrollEndTolerance,
  indexes,
  onIndexClick,
  selected,
  autoScrollToActiveIndex,
  autoScrollToActiveIndexOffsetX = AUTO_SCROLL_TO_ACTIVE_INDEX_OFFSET_X,
}) => {
  const scrollerContentElDefaultRef: NonNullable<
    ScrollerProps['contentContainerElRef']
  > = useRef(null);
  const innerScrollerContentElRef = contentContainerElRef
    ?? scrollerContentElDefaultRef;

  return (
    <IosArrowHorizontalScroller
      arrowLeftContainerClassName={arrowLeftContainerClassName}
      arrowRightContainerClassName={arrowRightContainerClassName}
      autoSnapScrollEnd={autoSnapScrollEnd}
      autoSnapScrollEndDebounceWaitMesc={autoSnapScrollEndDebounceWaitMesc}
      className={className}
      contentContainerClassName={contentContainerClassName}
      contentContainerElRef={innerScrollerContentElRef}
      scrollDebounceWaitMsec={scrollDebounceWaitMsec}
      scrollDistance={scrollDistance}
      scrollEndTolerance={scrollEndTolerance}>
      <div className={styles.containerRoot}>
        {indexes.map(index => (
          <button
            key={index.key}
            data-key={index}
            onClick={(e) => {
              onIndexClick?.(index);

              const { target } = e;

              if (!(target instanceof HTMLElement)
                || !autoScrollToActiveIndex) {
                return;
              }

              innerScrollerContentElRef.current?.scrollTo({
                left: target.offsetLeft + autoScrollToActiveIndexOffsetX,
                behavior: 'smooth',
              });
            }}>
            <span className={selected?.key === index.key
              ? styles.textActiveLetter
              : styles.textLetter}>
              {index.displayValue}
            </span>
          </button>
        ))}
      </div>
    </IosArrowHorizontalScroller>
  );
};
